import React, { useState } from 'react';
import { CheckCircle2Icon, Loader2Icon, LockIcon } from 'lucide-react';
import { services } from '../data/services';
import { site } from '../data/site';
type Status = 'idle' | 'submitting' | 'success' | 'error';
type QuoteFormProps = {
  defaultService?: string;
};
export function QuoteForm({
  defaultService = ''
}: QuoteFormProps) {
  const [status, setStatus] = useState<Status>('idle');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [service, setService] = useState(defaultService);
  const [details, setDetails] = useState('');
  const [error, setError] = useState('');
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || phone.replace(/\D/g, '').length < 10 || !service) {
      setError('Please add your name, a 10-digit phone number and the service you need.');
      setStatus('error');
      return;
    }
    setError('');
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  if (status === 'success') {
    return <div className="flex flex-col items-center py-8 text-center" role="status" data-id="element-291" data-mp="3gpup9imyi9mc">
        <CheckCircle2Icon className="h-14 w-14 text-brand" aria-hidden="true" data-id="element-292" data-mp="3lncw93heyerp" />
        <h3 className="mt-4 font-display text-3xl font-bold text-ink" data-id="element-293" data-mp="3qkv22l04wdvh">You’re on the list, {name.split(' ')[0]}.</h3>
        <p className="mt-2 max-w-xs text-ink-muted" data-id="element-294" data-mp="3up2p8dqy1lrl">
          We’ll call you within one business day with your free quote. Need it sooner?
        </p>
        <a href={site.phoneHref} className="mt-5 font-display text-2xl font-bold text-brand" data-id="element-295" data-mp="8g1edzh5d0p5">
          Call {site.phone}
        </a>
      </div>;
  }
  const inputClass = 'w-full rounded-lg border border-line bg-white px-4 py-3 text-base text-ink placeholder:text-ink-muted/70 outline-none transition-colors duration-150 focus:border-brand focus:ring-2 focus:ring-brand/20';
  return <form onSubmit={onSubmit} noValidate className="space-y-3" data-id="element-296" data-mp="r6j5jzmbzo8e">
      <div className="grid gap-3 sm:grid-cols-2" data-id="element-297" data-mp="r4pyij7t31zv">
        <label className="block" data-id="element-298" data-mp="2n95sxwgjelzy">
          <span className="sr-only" data-id="element-299" data-mp="2nagyo1tjm3tp">Full name</span>
          <input className={inputClass} placeholder="Full name" value={name} onChange={e => setName(e.target.value)} autoComplete="name" data-id="element-300" data-mp="2j8vnqm0kjzm5" />
        </label>
        <label className="block" data-id="element-301" data-mp="2s7z43i8cq0wy">
          <span className="sr-only" data-id="element-302" data-mp="2s6xkgpd9s63m">Phone number</span>
          <input className={inputClass} placeholder="Phone number" type="tel" value={phone} onChange={e => setPhone(e.target.value)} autoComplete="tel" data-id="element-303" data-mp="36wvcjgeblfy3" />
        </label>
      </div>
      <label className="block" data-id="element-304" data-mp="3azi7vra79j01">
        <span className="sr-only" data-id="element-305" data-mp="3az9rvqis5xkm">Service needed</span>
        <select className={`${inputClass} ${service ? '' : 'text-ink-muted/70'}`} value={service} onChange={e => setService(e.target.value)} data-id="element-306" data-mp="3axp1md3i10sk">
          <option value="" data-id="element-307" data-mp="1gnlcxocjtv08">What needs fixing?</option>
          {services.map(s => <option key={s.id} value={s.id} data-id="element-308" data-mp="3s9m5uvjfctdp">
              {s.name}
            </option>)}
          <option value="other" data-id="element-309" data-mp="11rh4nqfifak">Something else</option>
        </select>
      </label>
      <label className="block" data-id="element-310" data-mp="3jfqzxlahayx0">
        <span className="sr-only" data-id="element-311" data-mp="3jepnbcdte4d6">Project details</span>
        <textarea className={`${inputClass} resize-none`} rows={3} placeholder="Briefly describe the job (optional)" value={details} onChange={e => setDetails(e.target.value)} data-id="element-312" data-mp="3nh2jb92renwr" />
      </label>

      {status === 'error' && <p className="text-sm font-medium text-red-600" role="alert" data-id="element-313" data-mp="30ig2m68eqfk7">
          {error}
        </p>}

      <button type="submit" disabled={status === 'submitting'} className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand py-4 font-display text-xl font-bold uppercase tracking-wide text-white transition-colors duration-150 hover:bg-brand-dark disabled:opacity-80" data-id="element-314" data-mp="34kb172yyeeua">
        {status === 'submitting' ? <>
            <Loader2Icon className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-315" data-mp="92fej1zb7asf" /> Sending…
          </> : 'Get My Free Quote'}
      </button>
      <p className="flex items-center justify-center gap-1.5 text-xs text-ink-muted" data-id="element-316" data-mp="455s7v77vf8t">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-317" data-mp="3v946n0vixhgr" /> No spam, no obligation. We reply within 1 business day.
      </p>
    </form>;
}